import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "#10239E",
  "clip-path": "url(#a)"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13.993 7.083c.176 1.947.13 3.9-.134 5.834h4.829c.633-1.816.633-4.018 0-5.834zM6.007 7.083H1.312c-.634 1.816-.634 4.018 0 5.834h4.83a26 26 0 0 1-.135-5.834M7.114 13.75a24.8 24.8 0 0 0 1.545 5.317 9.2 9.2 0 0 0 2.682 0 24.8 24.8 0 0 0 1.546-5.317zM18.361 6.25a9.2 9.2 0 0 0-5.538-4.97l.26.91q.575 2.015.825 4.06zM6.982 12.917h6.036c.272-1.932.32-3.887.138-5.834H6.845c-.182 1.947-.135 3.9.137 5.834M13.066 6.25c-.197-1.727-.68-3.538-1.182-5.22a9.2 9.2 0 0 0-3.768 0l-.397 1.389a26 26 0 0 0-.785 3.831zM6.268 13.75h-4.63a9.2 9.2 0 0 0 6.044 5.12c-.662-1.658-1.116-3.393-1.414-5.12M12.474 18.478l-.157.391a9.2 9.2 0 0 0 6.044-5.119h-4.629a26.4 26.4 0 0 1-1.258 4.727M6.092 6.25c.193-1.661.598-3.35 1.085-4.97a9.2 9.2 0 0 0-5.538 4.97z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h20v20H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }